import api from "./api"


export const getProducts = async () => {
  const response = await api.get("/products")
  return response.data
}


export const getProductById = async (
  productId
) => {
  const response = await api.get(
    `/products/${productId}`
  )

  return response.data
}


export const getNextProductCode = async () => {
  const response = await api.get(
    "/products/next-code"
  )

  return response.data
}


export const createProduct = async (
  productData
) => {
  const response = await api.post(
    "/products",
    productData
  )

  return response.data
}


export const updateProduct = async (
  productId,
  productData
) => {
  const response = await api.put(
    `/products/${productId}`,
    productData
  )

  return response.data
}


export const deleteProduct = async (
  productId
) => {
  const response = await api.delete(
    `/products/${productId}`
  )

  return response.data
}